import { fg } from '@atlassian/jira-feature-gating';

const appendAgilityReferrer = (url: string) => `${url}&referrer=agility`;

/** @deprecated the "All Work" tab containing PIN can be removed in Nav4. Navigating to this URL can result in a 404. This is to be removed when cleaning up blu-7719_show_done_issues_in_gin_instead_of_pin */
export const getProjectIssueNavigatorUrl = (contextPath: string, projectKey: string) =>
	`${contextPath}/projects/${projectKey}/issues`;

/** @deprecated the "All Work" tab containing PIN can be removed in Nav4. Navigating to this URL can result in a 404. This is to be removed when cleaning up blu-7719_show_done_issues_in_gin_instead_of_pin */
export const getNextGenProjectIssueNavigatorUrl = (contextPath: string, projectKey: string) =>
	`${contextPath}/jira/software/projects/${projectKey}/issues/`;

export const getResolvedIssuesUrl = (contextPath: string, projectKey: string) =>
	fg('blu-7719_show_done_issues_in_gin_instead_of_pin')
		? appendAgilityReferrer(
				`${contextPath}/issues/?jql=${encodeURIComponent(
					`project = ${projectKey} AND statusCategory = Done ORDER BY created DESC`,
				)}`,
			)
		: appendAgilityReferrer(
				`${getNextGenProjectIssueNavigatorUrl(contextPath, projectKey)}?filter=doneissues`,
			);

export const getOldIssuesUrl = (contextPath: string, projectKey: string) =>
	`${contextPath}/issues/?jql=${encodeURIComponent(
		`project = ${projectKey} AND (fixVersion in unreleasedVersions() OR fixVersion is EMPTY) AND statusCategory = Done AND updated <= -2w ORDER BY Rank ASC`,
	)}`;
